import React from 'react';
import { TimelineDetailPageContainer } from '../../../../components/TimelineDetailPageContainer';

export const TimelineOrganizationEventDetails: React.FC = () => (
    <TimelineDetailPageContainer
        testId="timeline-organization-event-details"
        appRoute={{ type: 'TimelineOrganization' }}
    ></TimelineDetailPageContainer>
);
